<template>
    <el-container>
        <el-header style="height:auto" ref="elHeader">
            <el-form @submit.native.prevent :inline="true" :model="fromRole" ref="fromRole" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <!--                        <td-permission :roles="roles" style="float:right;">-->
                        <!--                            <div slot="havePermission">-->
                        <!--                                <el-form-item :label="$t('common.CURSYS')">-->
                        <!--                                    <td-select-->
                        <!--                                        v-model="fromRole.sSysFlg"-->
                        <!--                                        :placeholder="$t('common.PLEASE_SELECT')"-->
                        <!--                                        @change="queryPageBySys()"-->
                        <!--                                        :options="this.sysAndFlgList"-->
                        <!--                                        keys="sSysFlg"-->
                        <!--                                        text="sName"-->
                        <!--                                        :clearable="false"-->
                        <!--                                    >-->
                        <!--                                    </td-select>-->
                        <!--                                </el-form-item>-->
                        <!--                            </div>-->
                        <!--                        </td-permission>-->
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.ROLENAME')">
                                    <td-input placeholder="common.PLEASE_INPUT" v-model="fromRole.roleName"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click.native="btnReset">{{ $t('common.RESET') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- <el-row> -->
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in roleTypeList" :key="index" :label="item.sName" :name="item.sName">
                    <!-- <el-row> -->
                    <el-form>
                        <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddRole">{{ $t('common.ADD') }}</td-button>
                    </el-form>
                    <!-- </el-row> -->
                    <!-- <el-row> -->
                    <td-table
                        :columns="columns"
                        :height="tableHeight"
                        :permissions="permissionsView"
                        :dataSource="tableData"
                        :pageSize="pageSize"
                        :currentPage="currentPage"
                        :total="total"
                        :hasMutiSelect="false"
                        rowKey="roleId"
                        :hasLoading="loading"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                    ></td-table>
                    <!-- </el-row> -->
                </el-tab-pane>
            </el-tabs>
            <!-- </el-row> -->
        </el-main>
        <dialog-RoleInfo
            v-if="dialogRoleVisible"
            :isAddData="isAddData"
            :dialogRoleVisible="dialogRoleVisible"
            :sysList="this.sysList"
            :roleTypeList="roleTypeList"
            :sysFlg="this.fromRole.sSysFlg"
            :checkedMenu="checkedMenu"
            :checkedDept="checkedDept"
            :editItem="editItem"
            :title="title"
            ref="addOrModifyInfo"
            @roleDialogClose="roleDialogClose"
            @submit="submit"
            :orgTreeUrl="orgTreeUrl"
            :doorTreeUrl="doorTreeUrl"
            :authTrimingMap="authTrimingMap"
            :checkedAuthTriming="checkedAuthTriming"
            :currentRoleType="currentRoleType"
        ></dialog-RoleInfo>
    </el-container>
</template>
<script>
import dialogRoleInfo from './components/dialogRoleInfo.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-RoleInfo': dialogRoleInfo
    },

    activated() {},
    created() {
        this.tableHeight = document.body.clientHeight - 404 + 'px';
        this.tabsPage(window.authCommon.roleType.ordinaryRole);
        this.findRoleType();
        if (this.$common.systemInfo.systemId) {
            this.fromRole.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromRole.sSysFlg = 'PG';
        }
        let param = {};
        resourceApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                // this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
            // this.getMenuUrl();
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                }
            }
        });
        let params = {
            sTag: 'SYSTEM_ROLES'
        };
        resourceApi.getDictValuesByTag(params, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('/setting/dictController/getDictValuesByTag', response.data.statusMessage);
            }
            this.roles = [];
            if (response.data.content) {
                for (let index in response.data.content) {
                    if (response.data.content[index].sCode) {
                        this.roles.push(response.data.content[index].sCode);
                    }
                }
            }
        });
        this.getFinetuneResTypeList();
    },
    beforeDestroy() {
        // resourceApi = null;
        // dialogRoleInfo = null;
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        window.addEventListener('resize', e => {
            console.log(document.documentElement.clientHeight);
            this.tableHeight = document.body.clientHeight - 404 + 'px';
        });
        // this.rowDrop()
        // this.queryPageList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            roleTypeName: '',
            authTrimingMap: {}, //资源类型微调集合
            checkedAuthTriming: {}, //选中的资源操作类型
            currentRoleType: window.authCommon.roleType.ordinaryRole,
            activeName: this.$t('role.ORDINARY_ROLE'),
            val1: {},
            fromRole: {
                roleName: '',
                roleType: '',
                sSysFlg: ''
            },
            permissionsAdd: ['role:add'],
            permissionsEdit: ['role:edit'],
            permissionsView: ['role:view'],
            permissionsDel: ['role:del'],
            roles: ['admin'],
            sysList: [],
            sysAndFlgList: [],
            roleTypeList: [],
            editItem: '',
            dialogRoleVisible: false,
            menuUrl: '',
            deptUrl: '',
            hostUrl: '',
            menuList: [],
            deptList: [],
            tableData: [],
            checkedMenu: [],
            checkedDept: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            orgTreeUrl: { query: '', search: '' },
            doorTreeUrl: { query: '', search: '' },
            // 对表单进行数据验证
            rules: {
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'roleName',
                    label: this.$t('common.ROLENAME'),
                    sortable:true
                },
                // {
                //     prop: 'roleTypeName',
                //     label: this.$t('common.ROLE_TYPE')
                // },
                {
                    prop: 'roleDescription',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let result = [];
                        if (params.row.roleType !== 1) {
                            let editBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            );
                            let delBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.roleId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            );
                            if (this.roles.indexOf(params.row.roleId) < 0) {
                                result.push(editBtn);
                                result.push(delBtn);
                            }
                        }
                        return createElement('div', result);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //查询允许权限微调的资源
        getFinetuneResTypeList() {
            resourceApi.getFinetuneResTypeList(null, response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('res/getFinetuneResTypeList', response.data.statusMessage);
                    return;
                }
                this.authTrimingMap = response.data.content;
            });
        },

        // 重置
        btnReset() {
            this.fromRole.roleName = '';
            this.btnQuery();
        },
        //标签页
        handleClick(val) {
            this.val1 = val;
            this.roleTypeList.map(item => {
                if (item.sName == val.label) this.tabsPage(item.iTypeId);
            });
        },
        tabsPage(item) {
            this.currentRoleType = item;
            let param = {
                sysFlg: this.fromRole.sSysFlg,
                roleName: this.fromRole.roleName,
                roleType: item,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                excludeRoleTypeIds: [window.authCommon.roleType.orgRole]
            };
            resourceApi.listRoleInfos(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }

                let data = response.data.content;
                this.tableData = data;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        //查询角色类型
        findRoleType() {
            this.roleTypeList = [];
            resourceApi.queryAllRoleType('{}', response => {
                this.roleTypeName = response.data.content[0].sName;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('roleType/queryAllRoleType', response.data.statusMessage);
                    return;
                }
                if (!this.$util.isEmpty(response.data.content)) {
                    for (let i = 0; i < response.data.content.length; i++) {
                        const element = response.data.content[i];
                        if (element.iTypeId != window.authCommon.roleType.orgRole) {
                            this.roleTypeList.push(element);
                        }
                    }
                    this.fromRole.roleType = window.authCommon.roleType.ordinaryRole;
                    this.queryPageList(); // 进行页面初始化数据的加载
                }
            });
        },
        // 根据mq的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                // break
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryPageList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryPageList() {
            this.currentPage = 1;
            // this.getMenuUrl();
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            if (this.fromRole.sSysFlg !== 'nextPageValue' && this.fromRole.sSysFlg !== 'lastPageValue') {
                this.btnQuery();
                let arr = this.sysList;
                for (let index in arr) {
                    if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                        this.menuUrl = arr[index].sMenuUrl;
                        this.hostUrl = arr[index].sUrl;
                        this.deptUrl = arr[index].sDeptUrl;
                    }
                }
            }
        },
        getMenuUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                }
            }
            let param = {
                url: this.hostUrl,
                menuUrl: this.menuUrl,
                deptUrl: this.deptUrl
            };

            if (this.menuUrl !== '') {
                resourceApi.getMenuList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + this.menuUrl, response.data.statusMessage);
                        return;
                    }

                    this.menuList = response.data.content;
                });
            }
            if (this.deptUrl !== '') {
                resourceApi.getOrgList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + this.deptUrl, response.data.statusMessage);
                        return;
                    }
                    let deptData = response.data.content;
                    this.deptList = deptData;
                });
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sysFlg: this.fromRole.sSysFlg,
                roleName: this.fromRole.roleName,
                roleType: this.fromRole.roleType,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                excludeRoleTypeIds: [window.authCommon.roleType.orgRole]
            };
            resourceApi.listRoleInfos(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                if (this.activeName == this.roleTypeName) {
                    let data = response.data.content;
                    this.tableData = data;
                    this.total = response.data.count;
                    this.loading = false;
                }
                this.loading = false;
                let val = this.val1;
                this.roleTypeList.map(item => {
                    if (item.sName == val.label) this.tabsPage(item.iTypeId);
                });
            });
        },
        // 添加
        btnAddRole() {
            this.checkedAuthTriming = {};
            this.title = this.$t('common.ADD_ROLE'); // 标题
            this.isAddData = true;
            this.dialogRoleVisible = true;
            this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
            this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
            this.doorTreeUrl.query = this.hostUrl + '/device/queryDeviceOrgTree';
            this.doorTreeUrl.search = this.hostUrl + '/device/queryDeviceOrgTreeByName';
        },
        // 添加
        btnRefresh() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogRoleVisible = true;
        },
        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT_ROLE');
            this.isAddData = false;
            this.checkedAuthTriming = {};
            this.queryCheckedAuthTriming(row.roleId);
            this.dialogRoleVisible = true;
            this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
            this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
            this.doorTreeUrl.query = this.hostUrl + '/device/queryDeviceOrgTree';
            this.doorTreeUrl.search = this.hostUrl + '/device/queryDeviceOrgTreeByName';
        },
        //查询选中的微调资源
        queryCheckedAuthTriming(roleId) {
            resourceApi.getRoleFinetuneInfo(roleId, response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleFinetuneInfo', response.data.statusMessage);
                    return;
                }
                this.checkedAuthTriming = response.data.content;
            });
        },
        // 删除接口
        btnDelete(roleId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { roleId: roleId, sysFlg: this.fromRole.sSysFlg };
                    resourceApi.deleteRoleInfo(param, response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('role/deleteRoleInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('roleInfo/btnDelete---- Fail')
                });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 行拖拽
        // rowDrop () {
        //     const tbody = document.querySelector('.el-table__body-wrapper tbody')
        //     const _this = this
        //     Sortable.create(tbody, {
        //         onEnd ({ newIndex, oldIndex }) {
        //             const currRow = _this.tableData.splice(oldIndex, 1)[0]
        //             _this.tableData.splice(newIndex, 0, currRow)
        //         }
        //     })
        // },
        transData(a, idStr, pidStr, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                let hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            return r;
        },
        // 关闭页面
        roleDialogClose() {
            this.dialogRoleVisible = false;
        }
    }
};
</script>
<style scope>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
/* .el-button--small{
    font-size: 14px!important;
} */
</style>
